import { getPointCloudData } from "pages/unity/domain/getPointCloudData";

const discreteSliderConfig = {
  getPointCloudData
};

export default discreteSliderConfig;